module.exports = __webpack_public_path__ + "img/become_enterprise_member_friends.a52649af.jpg";